// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2Rpu2","col":"CardReaderDesc_col__34swz","label":"CardReaderDesc_label__2p-cG"};